import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ClientContactForm from "./components/ClientContactForm";
import Unsubscribe from "./components/Unsubscribe";
import ClientOnboarding from "./components/ClientOnboarding";
import ScrollToTop from "./components/ScrollToTop";

// Admin Components
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import EmailManagement from "./components/admin/EmailManagement";
import UserManagement from "./components/admin/UserManagement";
import ChangePassword from "./components/admin/ChangePassword";
import ForgotPassword from "./components/admin/ForgotPassword";
import ResetPassword from "./components/admin/ResetPassword";
import ClientManagement from "./components/admin/ClientManagement";
import ClientUserManagement from "./components/admin/ClientUserManagement";
import ImportCustomers from "./components/admin/ImportCustomers";
import ContentManagement from "./components/admin/ContentManagement";
import BlogManagement from "./components/admin/BlogManagement";
import BlogEditor from "./components/admin/BlogEditor";
import BlogCategories from "./components/admin/BlogCategories";
import CampaignManagement from "./components/admin/CampaignManagement";
import CampaignEditor from "./components/admin/CampaignEditor";
import CampaignLeads from "./components/admin/CampaignLeads";

// Client Portal Components
import ClientLogin from "./components/client/ClientLogin";
import ClientForgotPassword from "./components/client/ClientForgotPassword";
import ClientCreatePassword from "./components/client/ClientCreatePassword";
import ClientResetPassword from "./components/client/ClientResetPassword";
import ClientPortal from "./components/client/ClientPortal";
import JoinNow from "./pages/JoinNow";
import PurchaseFlow from "./pages/PurchaseFlow";

// Blog Components
import BlogListing from "./pages/BlogListing";
import BlogPost from "./pages/BlogPost";

// Campaign Landing Page
import CampaignPage from "./pages/CampaignPage";

// Policy Pages
import PolicyPage from "./pages/PolicyPage";

// Context Providers
import { HomepageContentProvider } from "./context/HomepageContentContext";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Client Contact Form Route - No navigation */}
          <Route path="/client-contact-request" element={<ClientContactForm />} />
          
          {/* Unsubscribe Route - No navigation */}
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          
          {/* Client Onboarding Route - No navigation */}
          <Route path="/client-onboarding" element={<ClientOnboarding />} />
          
          {/* Client Portal Routes */}
          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/client-forgot-password" element={<ClientForgotPassword />} />
          <Route path="/client-create-password/:token" element={<ClientCreatePassword />} />
          <Route path="/client-reset-password/:token" element={<ClientResetPassword />} />
          <Route path="/client-portal" element={<ClientPortal />} />
          
          {/* Landing Page */}
          <Route path="/join-now" element={<JoinNow />} />
          
          {/* Purchase Flow */}
          <Route path="/purchase" element={<PurchaseFlow />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/emails" element={<EmailManagement />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/clients" element={<ClientManagement />} />
          <Route path="/admin/client-users" element={<ClientUserManagement />} />
          <Route path="/admin/import-customers" element={<ImportCustomers />} />
          <Route path="/admin/content" element={<ContentManagement />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
          <Route path="/admin/blog" element={<BlogManagement />} />
          <Route path="/admin/blog/new" element={<BlogEditor />} />
          <Route path="/admin/blog/edit/:slug" element={<BlogEditor />} />
          <Route path="/admin/blog/categories" element={<BlogCategories />} />
          
          {/* Campaign Routes */}
          <Route path="/admin/campaigns" element={<CampaignManagement />} />
          <Route path="/admin/campaigns/new" element={<CampaignEditor />} />
          <Route path="/admin/campaigns/:slug/edit" element={<CampaignEditor />} />
          <Route path="/admin/campaigns/:slug/leads" element={<CampaignLeads />} />
          
          {/* Public Campaign Landing Page */}
          <Route path="/c/:slug" element={<CampaignPage />} />
          
          {/* Public Blog Routes */}
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          {/* Policy Pages */}
          <Route path="/policies/:policyType" element={<PolicyPage />} />
          <Route path="/cancellation-policy" element={<PolicyPage />} />
          
          {/* Main Website Route */}
          <Route path="/" element={
            <HomepageContentProvider>
              <Header />
              <main>
                <Hero />
                <Services />
                <About />
                <Contact />
              </main>
              <Footer />
            </HomepageContentProvider>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;